import React, {useEffect, useState, useContext, useRef} from 'react'
import {Container, Button, Grid, Typography, Box, TextField, MenuItem} from '@material-ui/core'
import WizardPreview from '../BarcodeWizardPreview'
import TooltipSettings from '../BarcodeToolTip'
import {fieldValueTooltip} from '../BarcodeToolTip/toolTipInfo'
import {createBarcodeSetting} from '../../graphql/barcode/mutations/barcodeSettingMutation'
import {Mutation} from 'react-apollo'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import {Query} from 'react-apollo'
import {scanningFields} from '../../graphql/barcode/queries/scanningFieldsQuery'
import LoadingScreen from '../BarcodeLoadingScreen'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeWizardFieldValueForm.styles'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeWizardContext} from '../../context/BarcodeWizard'
import {ToastMessageContext} from '../../context/ToastMessage'
import {BarcodeUrlSkipContext} from '../../context/BarcodeUrlSkip'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeWizardFieldValueForm(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const {barcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const {generateFormValue, setGenerateFormValue} = useContext(BarcodeWizardContext)
  const [formValues, setFormValues] = React.useState(
    generateFormValue || {
      name: '',
      output: '',
      template: barcodeLabelRecord ? barcodeLabelRecord : {},
      group: '',
      field: '',
    }
  )
  const [nameError, setNameError] = useState(false)
  const [outputError, setOutputError] = useState(false)
  const [fields, setFields] = useState([])
  const [fieldShow, setFieldShow] = useState([])
  const [redirectTo, setRedirectTo] = useState('library')
  const {urlGoTo} = useContext(BarcodeUrlSkipContext)
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const toast = useContext(ToastMessageContext)
  const refBtnSave = useRef(null)
  const currentUser = React.useContext(UserContext)


  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  const handleChange = textField => event => {
    if (textField === 'group') {
      selectFields(event.target.value)
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
        field: fields[event.target.value][0].id,
      })
    } else {
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
      })
    }
    setGenerateFormValue(formValues)
  }

  function handleSave(barcodeSetting, event) {
    if(!validateBarcodePermission(currentUser, "can_add")){
      return
    }
    if (checkValidity()) {
      barcodeSetting({
        variables: {
          accountId: userSettings.accountId,
          barcodeLabelId: parseInt(formValues.template.id),
          output: formValues.output,
          name: formValues.name,
          dataSource: 'from_objects',
          entityId: parseInt(formValues.group),
          fieldId: parseInt(formValues.field),
          digits: 3,
        },
      })
      setGenerateFormValue(formValues)
      setRedirectTo(event.currentTarget.value)
    }
  }

  function selectFields(entityId) {
    setFieldShow(fields[entityId])
  }

  function checkReturnData(data) {
    if (data.createBarcodeSetting.errors.length > 0) {
      toast.popMessage(data.createBarcodeSetting.errors, 'error', refBtnSave.current)
    } else {
      if (redirectTo === 'library') {
        props.history.push({
          pathname: 'barcode-library',
        })
      } else {
        props.history.push({
          pathname: 'barcode-wizard-generate-field-value',
          state: {
            barcodeData: data.createBarcodeSetting.barcodeSettings,
            previous: 'barcode-wizard-fields',
          },
        })
      }
    }
  }

  function checkValidity() {
    let errorMessage = ''
    setOutputError(false)
    setNameError(false)
    if (formValues.name === '') {
      errorMessage = t('barcode.wizard.field-value.error-name')
      setNameError(true)
    } else if (formValues.output === '') {
      errorMessage = t('barcode.wizard.field-value.error-output')
      setOutputError(true)
    }
    if (errorMessage === '') {
      return true
    } else {
      toast.popMessage(errorMessage, 'error', refBtnSave.current)
      return false
    }
  }

  return (
    <div>
      <BarcodeNavHeaderButtons
        previous={urlGoTo ? 'barcode-wizard' : 'barcode-wizard-generate-setting'}
      />

      <Query
        query={scanningFields}
        variables={{
          accountId: parseInt(userSettings.id),
          token: userSettings.token,
          userId: userId,
        }}
      >
        {({loading, error, data}) => {
          if (loading)
            return (
              <div>
                <LoadingScreen size={50} />
              </div>
            )
          if (error)
            return (
              <div>
                {props.history.push({
                  pathname: 'pageNotFound',
                })}
              </div>
            )

          if (data.scanningFields !== undefined) {
            setFields(data.scanningFields.fields)
            if (formValues.group === '' && formValues.field === '') {
              setFormValues({
                ...formValues,
                group: data.scanningFields.entities[0].id,
                field: data.scanningFields.fields[data.scanningFields.entities[0].id][0].id,
              })
              setFieldShow(data.scanningFields.fields[data.scanningFields.entities[0].id])
            } else if (fieldShow.length === 0 && formValues.group) {
              setFieldShow(data.scanningFields.fields[formValues.group])
            }
          }

          return (
            <div>
              <Grid container>
                <Grid item xs={6}>
                  <Container>
                    <Grid container>
                      <Grid container item xs={10} justify="flex-start">
                        <Typography variant="h5">
                          <Box marginTop={3}>
                            {t('barcode.wizard.field-value.generate-field-value')}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={2}
                        justify="flex-end"
                        className={classes.infoTooltipMargin}
                      >
                        <TooltipSettings size={16} tooltipInfo={fieldValueTooltip} />
                      </Grid>
                    </Grid>
                  </Container>
                  <Box marginTop={4} />
                  <Container>
                    <Grid container spacing={5}>
                      <Grid container item xs={8} justify="flex-end">
                        <TextField
                          id="outlined-name"
                          label={t('barcode.wizard.field-value.name')}
                          value={formValues.name}
                          fullWidth
                          variant="outlined"
                          onChange={handleChange('name')}
                          error={nameError}
                        />
                      </Grid>

                      <Grid container item xs={4} justify="flex-start">
                        <TextField
                          id="outlined-select-output"
                          select
                          label={t('barcode.wizard.field-value.output')}
                          className={classes.menuBar}
                          value={formValues.output}
                          fullWidth={true}
                          onChange={handleChange('output')}
                          error={outputError}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                        >
                          {['PDF', 'PNG'].map(output => (
                            <MenuItem key={output} value={output}>
                              {output}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                    <Box marginTop={3} />
                    <Grid container spacing={5}>
                      <Grid container item xs={12} justify="flex-end">
                        <TextField
                          id="outlined-select-template"
                          select
                          label={t('barcode.wizard.field-value.label-template')}
                          className={classes.menuBar}
                          value={formValues.template}
                          fullWidth={true}
                          onChange={handleChange('template')}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                          disabled
                        >
                          <MenuItem value={formValues.template}>
                            {formValues.template.name}
                          </MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                    <Box marginTop={3} />

                    <Grid container spacing={5}>
                      <Grid container item xs={8} justify="flex-end">
                        <TextField
                          id="outlined-select-output"
                          select
                          label={t('barcode.wizard.field-value.group')}
                          className={classes.menuBar}
                          value={formValues.group}
                          fullWidth={true}
                          onChange={handleChange('group')}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                        >
                          {data.scanningFields.entities.map((output, index) => (
                            <MenuItem key={output.id} value={output.id}>
                              {output.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid container item xs={4} justify="flex-start">
                        <TextField
                          id="outlined-select-output"
                          select
                          label={t('barcode.wizard.field-value.field')}
                          className={classes.menuBar}
                          value={formValues.field}
                          fullWidth={true}
                          onChange={handleChange('field')}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                        >
                          {fieldShow.map(output => (
                            <MenuItem key={output.id} value={output.id}>
                              {output.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>

                    <Box marginTop={3} />
                    <Grid container spacing={5} justify="flex-end">
                      <Mutation
                        mutation={createBarcodeSetting}
                        refetchQueries={() => [
                          {
                            query: libraryPageQuery,
                            variables: {
                              accountId: userSettings.accountId,
                              token: accessToken,
                              userId: userId,
                              filter: '',
                            },
                          },
                        ]}
                        awaitRefetchQueries
                        onCompleted={data => checkReturnData(data)}
                      >
                        {(createBarcodeSetting, {data, loading}) => {
                          if (loading)
                            return (
                              <div>
                                <LoadingScreen size={50} />
                              </div>
                            )
                          return (
                            <div>
                              <Button
                                ref={refBtnSave}
                                value="library"
                                variant="outlined"
                                className={classes.buttonLink}
                                disabled = {!validateBarcodePermission(currentUser, "can_add")}
                                color="primary"
                                onClick={e => handleSave(createBarcodeSetting, e)}
                              >
                                {t('barcode.wizard.field-value.save-library')}
                              </Button>

                              <Button
                                value="generate"
                                variant="contained"
                                className={classes.buttonLink}
                                disabled = {!validateBarcodePermission(currentUser, "can_add")}
                                color="primary"
                                onClick={e => handleSave(createBarcodeSetting, e)}
                              >
                                {t('barcode.wizard.field-value.save-select')}
                              </Button>
                            </div>
                          )
                        }}
                      </Mutation>
                    </Grid>
                  </Container>
                </Grid>

                <Grid container item xs={6}>
                  <WizardPreview />
                </Grid>
              </Grid>
            </div>
          )
        }}
      </Query>
    </div>
  )
}
